
export function bandFetchAction(name) {
  return (dispatch, getState) =>{
    let lowerCased = name.toLowerCase()
    let target = lowerCased.replace(/ /g, "_")
    dispatch({
      type: "SET_EMPTY_FETCHED_ARTIS",
    })
    dispatch({
      type: "SET_EMPTY_FETCHED_ARTIS_ALBUM",
    })
    fetch("https://www.theaudiodb.com/api/v1/json/1/search.php?s=" + target)
      .then((resp) => resp.json())
      .then((data) => {
        dispatch({
          type: "ADD_FETCHED_ARTIS",
          payload: [data.artists[0]]
        })
        return fetch("https://www.theaudiodb.com/api/v1/json/1/searchalbum.php?s=" + target)
      })
      .then((resp) => resp.json())
      .then((data) => {
        dispatch({
          type: "ADD_FETCHED_ARTIS_ALBUM",
          payload: data.album
        })
        // return setFetchedBandAlbums(data.album);
      })
      .catch(err => {
        console.log(err);
      })
  }
}
